import { isScheduleOpen } from "@/utils/time.js";

// Terminal schedule overrides:
// - If terminal has per-order-flow schedule override, use those schedules
// - Else if terminal has global schedule override, use those schedules
// - Else, use all schedules
export function applyTerminalScheduleOverrides(allSchedules, terminalConfig, orderTypeId) {
  const schedules = Array.isArray(allSchedules) ? allSchedules : [];
  const cfg = terminalConfig || {};

  // 1) Per-order-flow override
  if (
    cfg.orderFlowSchedules &&
    orderTypeId &&
    Array.isArray(cfg.orderFlowSchedules[orderTypeId]) &&
    cfg.orderFlowSchedules[orderTypeId].length > 0
  ) {
    const allowed = new Set(cfg.orderFlowSchedules[orderTypeId]);
    return schedules.filter(s => allowed.has(s.ref));
  }

  // 2) Global override (legacy)
  if (Array.isArray(cfg.schedules) && cfg.schedules.length > 0) {
    const allowed = new Set(cfg.schedules);
    return schedules.filter(s => allowed.has(s.ref));
  }

  // 3) Default: all schedules
  return schedules;
}

export function filterOpenSchedules(schedules, now, ignoreScheduleHours) {
  const list = Array.isArray(schedules) ? schedules : [];
  if (ignoreScheduleHours) return list;
  if (!(now instanceof Date)) return [];
  return list.filter(schedule => isScheduleOpen(schedule, now, false));
}

// Merge schedules into a single departments array without duplicating departments or items.
// - Department is keyed by `department.ref`
// - Item is keyed by `item.ref` within a department
export function mergeSchedulesToDepartments(schedules) {
  const list = Array.isArray(schedules) ? schedules : [];
  const departmentsByRef = new Map();
  const departmentOrder = [];

  list.forEach(schedule => {
    (schedule.departments || []).forEach(dept => {
      if (!dept?.ref) return;

      let merged = departmentsByRef.get(dept.ref);
      if (!merged) {
        merged = { ...dept, items: [] };
        departmentsByRef.set(dept.ref, merged);
        departmentOrder.push(dept.ref);
      }

      const existingItemRefs = new Set((merged.items || []).map(x => x.ref));
      (dept.items || []).forEach(item => {
        if (!item?.ref) return;
        if (!existingItemRefs.has(item.ref)) {
          merged.items.push(item);
          existingItemRefs.add(item.ref);
        }
      });
    });
  });

  return departmentOrder.map(ref => departmentsByRef.get(ref)).filter(Boolean);
}

export function buildAvailableMenuView({
  allSchedules,
  terminalConfig,
  orderTypeId,
  now,
  ignoreScheduleHours,
}) {
  const effectiveSchedules = applyTerminalScheduleOverrides(
    allSchedules,
    terminalConfig,
    orderTypeId,
  );
  const openSchedules = filterOpenSchedules(effectiveSchedules, now, ignoreScheduleHours);
  const departments = mergeSchedulesToDepartments(openSchedules);

  const availableItemRefs = new Set();
  departments.forEach(dept => {
    (dept.items || []).forEach(item => {
      if (item?.ref) availableItemRefs.add(item.ref);
    });
  });

  return { effectiveSchedules, openSchedules, departments, availableItemRefs };
}


